
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth/login-as-manager",
      function () {
        return require("private-next-pages/auth/login-as-manager/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth/login-as-manager"])
      });
    }
  